import React from "react";
import "./styles.css"; // Import the stylesheet

const SemiCircularProgressBar = ({
  value,
  max = 100,
  label,
  size = 290,
  stroke = 20,
  title = "Something",
  startTitle,
  endTitle,
}) => {
  const radius = (size - stroke) / 2;
  const circ = Math.PI * radius;

  // --- MODIFICATION START ---

  // Check for the special case where value is 0.
  const isValueZero = value === 0;

  // Determine the stroke color. If value is 0, use solid red. Otherwise, use the gradient.
  const strokeColor = isValueZero ? "#D0213D" : "url(#progressGradient)";

  // Determine the percentage. If value is 0, the bar is full (100%).
  // Otherwise, calculate the percentage normally, ensuring max is not zero to prevent errors.
  const percentage = isValueZero ? 1 : max > 0 ? Math.min(value, max) / max : 0;

  // The offset determines how much of the circle is "empty".
  // A full bar (percentage=1) has an offset of 0.
  const offset = circ - percentage * circ;

  // --- MODIFICATION END ---

  const padding = 2; // Minimal padding around the semicircle
  const viewBoxWidth = size + padding * 2;
  const viewBoxHeight = size / 2 + padding + stroke / 2;

  return (
    <div className="progress-bar-container">
      <div className="progress-bar-title">{title}</div>
      <div className="svg-wrapper">
        <svg
          viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
          className="progress-bar-svg"
          preserveAspectRatio="xMidYMid meet">
          {/* Define the gradient (only used when value is not 0) */}
          <defs>
            <linearGradient
              id="progressGradient"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="0%">
              <stop offset="0%" stopColor="#D0213D" />
              <stop offset="50%" stopColor="#F7D100" />
              <stop offset="100%" stopColor="#008A29" />
            </linearGradient>
          </defs>

          {/* Center the semicircle in viewBox */}
          <g transform={`translate(${padding + stroke / 2}, ${padding})`}>
            {/* Background semicircle - Grey */}
            <path
              d={`
              M 0,${size / 2}
              a ${radius},${radius} 0 0,1 ${size - stroke},0
            `}
              fill="none"
              stroke="#e5e5e5" // Grey background
              strokeWidth={stroke}
              strokeLinecap="round"
            />

            {/* Progress semicircle - Conditionally colored */}
            <path
              d={`
              M 0,${size / 2}
              a ${radius},${radius} 0 0,1 ${size - stroke},0
            `}
              fill="none"
              stroke={strokeColor} // USE DYNAMIC COLOR
              strokeWidth={stroke}
              strokeDasharray={circ}
              strokeDashoffset={offset} // USE CALCULATED OFFSET
              strokeLinecap="round"
              style={{ transition: "stroke-dashoffset 0.5s" }}
            />

            {/* Centered text */}
            <text
              x={(size - stroke) / 2}
              y={size / 2 - 15}
              textAnchor="middle"
              dominantBaseline="middle"
              className="progress-bar-value-text">
              {value}
              {label}
            </text>
          </g>
        </svg>
        {/* Conditionally render the labels */}
        {(startTitle || endTitle) && (
          <div className="progress-bar-labels">
            <span className="progress-bar-start-label">{startTitle}</span>
            <span className="progress-bar-end-label">{endTitle}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default SemiCircularProgressBar;
